import { Label } from "components/Atoms/Label";
import React from "react";

interface Props<T extends unknown> {
  value: T[];
  renderLabelContent: (value: T) => React.ReactNode
  getId: (value: T) => string | number;
}

export const LabelList = <T extends unknown>(props: Props<T>) => {
  if (props.value.length === 0) {
    return <></>;
  }

  return <div className="removableLabel-list">
    {props.value.map(i => <Label
      key={props.getId(i)}
    >
      {props.renderLabelContent(i)}
    </Label>)}
  </div>;
}